
import { defineComponent } from 'vue'

// paper information
interface PaperInfo {
  title: string,
  author: string,
  arxiv?: string,
  journal?: string,
  volume?: string,
  page?: string,
  year?: number,
  url?: string,
  note?: string,
  bibtex: string
}

export default defineComponent({
  data () {
    return {
      papers: [
        {
          title: 'Finite-Momentum Superconductivity in ‘Third-Type Magnets’: Toward Realization of the Superconducting Diode Effect',
          author: '<u>Shuntaro Sumita</u>',
          journal: 'JPSJ News and Comments',
          volume: '22',
          page: '08',
          year: 2025,
          url: 'https://journals.jps.jp/doi/10.7566/JPSJNC.22.08',
          note: '[a short review on <a href="https://journals.jps.jp/doi/full/10.7566/JPSJ.94.064705" target="_blank">J. Phys. Soc. Jpn. 94, 064705 (2025)</a>.]',
          bibtex:
          `@article{JPSJ.22.08,
  author = {Sumita, Shuntaro},
  title = {{Finite-Momentum Superconductivity in ‘Third-Type Magnets’: Toward Realization of the Superconducting Diode Effect}},
  journal = {JPSJ News and Comments},
  volume = {22},
  pages = {08},
  year = {2025},
  doi = {10.7566/JPSJNC.22.08}
  url = {https://journals.jps.jp/doi/10.7566/JPSJNC.22.08}
}`
        },
        {
          title: '遍歴強相関電子系における多極子秩序の理論',
          author: '<u>角田 峻太郎</u>',
          journal: 'アシンメトリ量⼦若⼿秋の学校：改訂版 (広島大学 学術情報リポジトリ)',
          page: '249',
          year: 2024,
          url: 'https://doi.org/10.15027/55825',
          bibtex:
          `@article{Asymmetry2024_Sumita,
  title = {遍歴強相関電子系における多極子秩序の理論},
  author = {角田 峻太郎},
  journal = {アシンメトリ量⼦若⼿秋の学校：改訂版},
  pages = {249},
  year = {2024},
  doi = {10.15027/55825},
  url = {https://doi.org/10.15027/55825}
}`
        },
        {
          title: 'Topological gapless points in superconductors: From the viewpoint of symmetry',
          author: '<u>Shuntaro Sumita</u> and Youichi Yanase',
          arxiv: '2107.05801',
          journal: 'Prog. Theo. Exp. Phys.',
          volume: '2022',
          page: '04A102',
          year: 2022,
          url: 'https://doi.org/10.1093/ptep/ptab124',
          note: `[an invited review paper; <b><span class="text-success">Editor's Choice</span></b>.]<br/>
          <a href="https://doi.org/10.7566/JPSHT.1.068" target="_blank">JPS Hot Topics</a>で紹介されました．`,
          bibtex:
          `@article{ptep.2022.04A102,
  author = {Sumita, Shuntaro and Yanase, Youichi},
  title = {{Topological gapless points in superconductors: From the viewpoint of symmetry}},
  journal = {Progress of Theoretical and Experimental Physics},
  volume = {2022},
  number = {4},
  pages = {04A102},
  year = {2022},
  month = {10},
  issn = {2050-3911},
  doi = {10.1093/ptep/ptab124},
  url = {https://doi.org/10.1093/ptep/ptab124}
}`
        },
        {
          title: '奇パリティ多極子相の分類学と電磁応答・超伝導',
          author: '渡邉 光，栁瀬 陽一，石塚 淳，金杉 翔太，大同 暁人，<u>角田 峻太郎</u>，下出 敦夫，塩見 雄毅',
          journal: '固体物理',
          volume: '55',
          page: '535',
          year: 2020,
          url: 'https://www.agne.co.jp/kotaibutsuri/kota1055.htm#no657',
          bibtex:
          `@article{KotaiButsuri.55.535,
  title = {奇パリティ多極子相の分類学と電磁応答・超伝導},
  author = {渡邉 光 and 栁瀬 陽一 and 石塚 淳 and 金杉 翔太 and 大同 暁人 and 角田 峻太郎 and 下出 敦夫 and 塩見 雄毅},
  journal = {固体物理},
  volume = {55},
  issue = {11},
  pages = {535},
  year = {2020},
  publisher = {アグネ技術センター}
}`
        },
        {
          title: '超伝導ギャップ構造の現代的分類理論',
          author: '<u>角田 峻太郎</u>，小林 伸吾',
          journal: '固体物理',
          volume: '55',
          page: '463',
          year: 2020,
          url: 'https://www.agne.co.jp/kotaibutsuri/kota1055.htm#no656',
          bibtex:
          `@article{KotaiButsuri.55.463,
  title = {超伝導ギャップ構造の現代的分類理論},
  author = {角田 峻太郎 and 小林 伸吾},
  journal = {固体物理},
  volume = {55},
  issue = {10},
  pages = {463},
  year = {2020},
  publisher = {アグネ技術センター}
}`
        }
      ] as PaperInfo[]
    }
  }
})
